import React from "react";
import PropTypes from "prop-types";

const Button = ({children, version, type, isDisabled}) => {
    if(isDisabled) {
        return (
            <button type = {type} className = {`btn disabled-btn`}>
                {children}
            </button>
        );
    } else return (
        <button type = {type} disabled = {isDisabled} className = {`btn btn-${version}`}>
            {children}
        </button>
    );
};

Button.defaultProps = {
    version: "primary",
    type: "button",
    isDisabled: false,
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    version: PropTypes.string,
    type: PropTypes.string,
    isDisabled: PropTypes.bool,
};

export default Button;
